/** Saisie d'un local : RAS ou une ou plusieurs anomalies.

Le bouton orange « Anomalie » n'écrivait rien : il vidait la case.
Un texte déjà enregistré qui n'est pas une option connue (par exemple le mot
Anomalie) reste dans la chaîne et s'affiche tel quel. On ne le réécrit pas
au chargement.
*/

export function splitControlEntries(value) {
  return String(value || '').split(', ').map((part) => part.trim()).filter(Boolean);
}

export function controlCategory(entry) {
  const match = String(entry || '').match(/^(.*?)\s*\(([^)]*)\)\s*$/);
  return match ? match[1].trim() : String(entry || '').trim();
}

/** RAS remplace les anomalies. Une anomalie retire RAS, sans effacer un texte hérité. */
export function toggleControlOption(value, option) {
  const parts = splitControlEntries(value);
  if (option === 'RAS') {
    const onlyRas = parts.length === 1 && controlCategory(parts[0]) === 'RAS';
    return onlyRas ? '' : 'RAS';
  }
  const kept = parts.filter((part) => controlCategory(part) !== 'RAS');
  const index = kept.findIndex((part) => controlCategory(part) === option);
  if (index >= 0) kept.splice(index, 1);
  else kept.push(option);
  return kept.join(', ');
}

/** Parties stockées qui ne sont ni RAS ni une option proposée. */
export function unmatchedControlParts(value, options) {
  const known = new Set(options || []);
  return splitControlEntries(value).filter((part) => {
    const category = controlCategory(part);
    return category && category !== 'RAS' && !known.has(category);
  });
}
